"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tabs = {
    baseStyle: {
        root: {
            flex: 1,
        },
        tablist: {
            width: 'fit-content',
        },
        tabpanels: {
            flex: 1,
        },
        tabpanel: {
            flex: 1,
            padding: 0,
        },
    },
    parts: ['tablist', 'tab', 'tabpanels', 'tabpanel', 'indicator'],
    variants: {
        // DEPRECATED
        line: {
            tablist: {
                borderColor: 'gray.200',
                marginY: 2,
            },
            tab: {
                borderRadius: '0',
                color: 'blueGray.800',
                fontWeight: 'bold',
                _selected: {
                    color: 'blue.600',
                },
            },
        },
        // DEPRECATED
        guide: {
            tablist: {
                borderBottom: '1px solid',
                borderColor: 'inherit',
                marginBottom: '-1px',
            },
            tab: {
                borderTopLeftRadius: 'md',
                borderTopRightRadius: 'md',
                border: 'solid 1px',
                borderColor: 'transparent',
                marginBottom: '-1px',
                _selected: {
                    backgroundColor: 'var(--chakra-colors-gray-100)',
                    border: 'solid 1px silver',
                    color: 'var(--chakra-colors-blue-600)',
                    borderBottomColor: 'transparent',
                },
            },
        },
        orange: {
            tablist: {
                paddingTop: 2,
                paddingLeft: 4,
                borderColor: 'gray.200',
                fontSize: 'md',
            },
            tab: {
                paddingX: 0,
                paddingY: 2,
                marginRight: 6,
                fontSize: 'md',
                color: 'blueGray.600',
                fontWeight: '400',
                _selected: {
                    color: 'blueGray.900',
                    fontWeight: '500',
                },
            },
            tabpanels: {
                paddingX: 4,
                paddingY: 4,
            },
            indicator: {
                height: '2px',
                backgroundColor: 'red.500',
                marginTop: '-2px',
            },
        },
    },
};
exports.default = Tabs;
